export default __webpack_public_path__ + "static/Hero_06_RiskManagement-034a5d3455b06c9ad5598a3828e8fa18.jpg";